import './table-component.scss';
import { useVariableContext } from "../../variableContext";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useMemo } from 'react';
import CustomCell from '../custom-cell/custom-cell';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { IconButton, Avatar, Box } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { esES } from '@mui/x-data-grid/locales';

// Opciones de estado disponibles (equivalentes a mapZammadStateToDisplay)
const ESTADO_OPTIONS = ['Nuevo', 'En Proceso', 'Pendiente', 'Cerrado', 'Fusionado', 'Cierre pendiente'];

const initValueFrm = {
    "@odata.etag": "",
    "Title": "Soporte Administrativo - Operativo",
    "idLista": "6cad4cda-8b4d-4cfd-aea3-c4ad2f82cd28",
    "Habilitado": true,
    "Icon": "verde_intenso",
    "id": "1",
    "ContentType": "Elemento",
    "Modified": "2023-10-22T09:35:32Z",
    "Created": "2023-03-05T16:09:06Z",
    "AuthorLookupId": "9",
    "EditorLookupId": "9",
    "_UIVersionString": "8.0",
    "Attachments": false,
    "Edit": "",
    "LinkTitleNoMenu": "Soporte Administrativo - Operativo",
    "LinkTitle": "Soporte Administrativo - Operativo",
    "ItemChildCount": "0",
    "FolderChildCount": "0",
    "_ComplianceFlags": "",
    "_ComplianceTag": "",
    "_ComplianceTagWrittenTime": "",
    "_ComplianceTagUserId": ""
}


export default function Table({ columnsFrm = [], valuesRegister = [], nextPageLoader, nextLink = '' }) {

    const { root } = useVariableContext();
    const navigate = useNavigate();
    const { idForm } = useParams();
    const [infoFrm, setInfoFrm] = useState(initValueFrm);

    useEffect(() => {
        if (Object.keys(root).length === 0) {
            navigate('/');
        } else if (root.ListadoApp) {
            const defaultFrm = root.ListadoApp.find(x => x.idLista === idForm) || initValueFrm;
            setInfoFrm(defaultFrm);
        }
    }, [root, idForm, navigate]);

    // Construir columnas dinámicamente
    const columns = useMemo(() => {
        const cols = [
            {
                field: 'avatar',
                headerName: '',
                width: 80,
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
                renderCell: () => (
                    <Avatar
                        src={process.env.PUBLIC_URL + '/assets/icon/' + infoFrm.Icon + '.svg'}
                        alt="icon"
                        sx={{ width: 40, height: 40 }}
                    />
                )
            }
        ];

        // Agregar columnas dinámicas basadas en columnsFrm
        columnsFrm.forEach((column) => {
            cols.push({
                field: column.name,
                headerName: column.displayName,
                flex: 1,
                minWidth: 150,
                renderCell: (params) => (
                    <CustomCell columnKey={column} rowData={params.row} />
                )
            });
        });

        // Agregar columna de Estado si existe en los datos
        if (valuesRegister.length > 0 && valuesRegister[0].Estado) {
            cols.push({
                field: 'Estado',
                headerName: 'Estado',
                flex: 1,
                minWidth: 130,
                type: 'singleSelect',
                valueOptions: ESTADO_OPTIONS,
                renderCell: (params) => (
                    <span className={`state ${params.value === 'Finalizado' ? 'state--confirmed' : ''}`}>
                        {params.value}
                    </span>
                )
            });
        }

        // Columna de acciones fija a la derecha
        cols.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerAlign: 'right',
            align: 'right',
            renderCell: (params) => (
                <IconButton
                    onClick={() => navigate(`/Listado/${infoFrm.idLista}/${params.row.id}`)}
                    color="primary"
                    size="small"
                >
                    <VisibilityIcon />
                </IconButton>
            )
        });

        return cols;
    }, [columnsFrm, infoFrm, navigate, valuesRegister]);

    // Preparar filas con IDs únicos
    const rows = useMemo(() => {
        return valuesRegister.map((row, index) => ({
            ...row,
            id: row.id || index
        }));
    }, [valuesRegister]);

    return (
        <div className='table-component'>
            <div className='table-component__container'>
                <section className="table-top">
                    <div>
                        <div onClick={() => navigate(-1)} className="back">Volver</div>
                    </div>
                    <div>
                        <button onClick={() => navigate('/FrmSolicitud/' + infoFrm.idLista)}>
                            Realizar Nueva Solicitud
                        </button>
                    </div>
                </section>
                <section className="table-body">
                    <div>
                        <h4>{infoFrm.Title}</h4>
                    </div>

                    <Box sx={{ height: 600, width: '100%', mt: 2 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[10, 25, 50]}
                            disableSelectionOnClick
                            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            components={{
                                Toolbar: GridToolbar,
                            }}
                            componentsProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                }
                            }}
                            sx={{
                                '& .MuiDataGrid-cell:focus': {
                                    outline: 'none',
                                },
                                '& .MuiDataGrid-row:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    backgroundColor: '#f5f5f5',
                                    fontWeight: 'bold',
                                },
                            }}
                        />
                    </Box>

                    {nextLink && (
                        <div className="pagination" style={{ marginTop: '16px' }}>
                            <button className="right" onClick={nextPageLoader}>
                                Siguiente Página
                            </button>
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
}


// {<div className='table'>
// <table>
//     <thead>
//         <tr>
//             <th></th>
//             <th >ID</th>
//             <th >Fecha</th>
//             <th >Titulo</th>
//             <th >Descripción</th>
//             <th >Estado</th>
//             <th >Ult. Modificación</th>
//             <th ></th>
//         </tr>
//     </thead>
//     <tbody>
//         <tr>
//             <td className='avatar'>
//                 <img src={process.env.PUBLIC_URL + '/assets/square-green.svg'} alt="" />
//             </td>
//             <td>
//                 <p className='bold'>0000001</p>
//             </td>
//             <td>
//                 <p className='bold'>3 abr, 2023</p>
//             </td>
//             <td>
//                 <p>Soporte para optimizar el proceso de facturación</p>
//             </td>
//             <td>
//                 <p>
//                     Esta solicitud se refiere a la necesidad de mejorar y optimizar el proceso de facturación de la empresa texti...
//                 </p>
//             </td>
//             <td className='state'>
//                 <p>En proceso</p>
//             </td>
//             <td>
//                 <p className='bold'>3 abr, 2023</p>
//             </td>
//             <td className='view'>
//                 <button onClick={() => navigate('/Listado/idForm/idSolicitud')}></button>
//             </td>
//         </tr>
//         <tr>
//             <td className='avatar'>
//                 <img src="" alt="" />
//             </td>
//             <td>
//                 <p className='bold'>0000001</p>
//             </td>
//             <td>
//                 <p className='bold'>3 abr, 2023</p>
//             </td>
//             <td>
//                 <p>Soporte para optimizar el proceso de facturación</p>
//             </td>                                    <td>
//                 <p>
//                     Esta solicitud se refiere a la necesidad de mejorar y optimizar el proceso de facturación de la empresa texti...
//                 </p>
//             </td>
//             <td className='state'>
//                 <p className='confirmed'>Resuelta</p>
//             </td>
//             <td>
//                 <p className='bold'>3 abr, 2023</p>
//             </td>
//             <td className='view'>
//                 <button onClick={() => navigate('/Listado/idForm/idSolicitud')}><span className='notification'></span></button>
//             </td>
//         </tr>
//         <tr>
//             <td className='avatar'>
//                 <img src="" alt="" />
//             </td>
//             <td>
//                 <p className='bold'>0000001</p>
//             </td>
//             <td>
//                 <p className='bold'>3 abr, 2023</p>
//             </td>
//             <td>
//                 <p>Soporte para optimizar el proceso de facturación</p>
//             </td>
//             <td>
//                 <p>
//                     Esta solicitud se refiere a la necesidad de mejorar y optimizar el proceso de facturación de la empresa texti...
//                 </p>
//             </td>
//             <td className='state'>
//                 <p>En proceso</p>
//             </td>
//             <td>
//                 <p className='bold'>3 abr, 2023</p>
//             </td>
//             <td className='view'>
//                 <button onClick={() => navigate('/Listado/idForm/idSolicitud')}></button>
//             </td>
//         </tr>
//     </tbody>
//     <tfoot>
//         <tr>
//             <td colSpan={7}>
//                 <label class="check">Deseo recibir notificaciones en mi escritorio de windows
//                     <input type="checkbox" />
//                     <span></span>
//                 </label>
//             </td>
//         </tr>
//     </tfoot>
// </table>
// </div>}